import {
  Paper,
  ScrollAreaAutosize,
  Stack,
  Stepper,
  Table,
} from '@mantine/core';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useOrderPage } from '../../hooks/use-order-page';

import classes from './page.module.css';

import { formatDate } from '@data-access';

export const OrderTrackPage: FC = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState(0);
  const { order } = useOrderPage();

  useEffect(() => {
    const steps = [
      order.data.plan_created,
      order.data.sampler_found,
      order.data.sampled,
      order.data.received_laboratory,
      order.data.received_results,
    ];

    // set active step based on order status 1 by 1 delayed to create animation
    let currentStep = 0;
    const interval = setInterval(() => {
      if (currentStep < steps.length && steps[currentStep]) {
        currentStep++;
        setActive(currentStep);
      } else {
        clearInterval(interval);
      }
    }, 80);
    return () => clearInterval(interval);
  }, [order.data]);

  return (
    <Paper h="100%" p={0} radius="sm" withBorder>
      <Stack h="100%" justify="space-between">
        <Stepper
          active={active}
          classNames={{
            // step: classes.step,
            stepLabel: classes.stepLabel,
          }}
          iconPosition="left"
          iconSize={80}
          p="md"
        >
          <Stepper.Step
            description={formatDate({
              date: order.data.plan_created_at,
              format: 'display',
            })}
            label={t('common.plan-cree')}
          />
          <Stepper.Step
            description={formatDate({
              date: order.data.sampler_found_at,
              format: 'display',
            })}
            label={t('common.preleveur-trouve')}
          />
          <Stepper.Step
            description={formatDate({
              date: order.data.sampled_at,
              format: 'display',
            })}
            label={t('common.preleve')}
          />
          <Stepper.Step
            description={formatDate({
              date: order.data.received_laboratory_at,
              format: 'display',
            })}
            label={t('common.receptionne-labo')}
          />
          <Stepper.Step
            description={formatDate({
              date: order.data.received_results_at,
              format: 'display',
            })}
            label={t('common.resultats-restitues')}
          />
        </Stepper>
        <ScrollAreaAutosize>
          <Table striped verticalSpacing="md" withRowBorders={false}>
            <Table.Tbody>
              {order.data.logs.map((log) => (
                <Table.Tr key={log.id}>
                  <Table.Td w="150px">
                    {formatDate({ date: log.date, format: 'display-hour' })}
                  </Table.Td>
                  <Table.Td>{log.message}</Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </ScrollAreaAutosize>
      </Stack>
    </Paper>
  );
};
